import React from 'react'

import LogoConstructora from './../../UI/Logos/logo-constructora.svg'

interface Props{
    isLoading: boolean,
    gettingProjectInfo: boolean,
    errorGettingProjectInfo: boolean,
    downloadingImagesInfo: boolean,
    errorDownloadingImages: boolean
}

interface State{}

class LoadingScreen extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isLoading ? "loading-div fade-in":"loading-div fade-out"}>
                <img src={LogoConstructora} className='logo-constructora'/>
                <svg className="loader-circle" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                    <circle className= 'internal-circle' cx="75" cy="75" r="70"></circle>
                </svg>
                <svg className="loader-circle-over" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                    <circle className= 'internal-circle-over' cx="75" cy="75" r="70"></circle>
                </svg>
                <div className='loading-info-container'>
                    <div className={this.props.gettingProjectInfo ? "fade-in":"fade-out"}>{this.props.errorGettingProjectInfo ? "Error obteniendo información":"Obteniendo información"}</div>
                    <div className={this.props.downloadingImagesInfo ? "fade-in":"fade-out"}>{this.props.errorDownloadingImages ? "Error descargando imagenes":"Descargando Imagenes"}</div>
                </div>
            </div>
        )
    }
}

export default LoadingScreen